
import api from "./api";


export const downloadQuejaFile = async (id) => {
  try {
    const response = await api.get(`/files/download/queja/${id}`, {
      responseType: 'blob', // Importante para archivos
      
    });
    return response;
  } catch (error) {
    console.error('Error descargando el archivo:', error);
    throw error;
  }
};
